<template>
    <dashboard>
        <row>
            <panel :wrap-buttons="true">
                <h2 slot="title">Locations</h2>
                <template slot="buttons">
                    <label title="Filter Locations" for="filter">
                        <span class="visuallyhidden">Type To Filter Locations</span>
                        <app-input
                            id="filter"
                            ref="locQuery"
                            v-model="query"
                            placeholder="Type location..."
                            prefix-icon="icon-search"
                            size="small"
                            @input="queryChange">
                            <template slot="prepend">Filter:</template>
                        </app-input>
                    </label>
                    <app-button size="small" @click="addNewLocation">Add Location</app-button>
                    <app-button
                        v-if="$role.isMasterAdmin()"
                        id="list-add-beacon"
                        size="small"
                        @click="showActivateBeacon = true">Add Beacon</app-button>
                </template>

                <el-table
                    :data="locations"
                    :default-sort="{ prop: sort_by }"
                    style="width: 100%"
                    empty-text="No Locations"
                    @current-change="navigateToLocationDetail"
                    @sort-change="sortChange">
                    <el-table-column 
                        prop="name" 
                        label="Name" 
                        sortable="custom"
                        min-width="150px">
                        <template slot-scope="scope">
                            <router-link
                                :aria-label="'Location: '+ scope.row.name"
                                :to="{ name: 'locations.detail', params: { id: scope.row.id } }">{{ scope.row.name }}</router-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="beacons_count"
                        label="# of Beacons"
                        sortable="custom"
                        width="150px"/>
                    <el-table-column
                        prop="courses_count"
                        label="# of Courses"
                        sortable="custom"
                        width="150px"/>
                    <el-table-column label align="right">
                        <template slot-scope="scope">
                            <app-tag
                                v-if="scope.row.beacons_count == 0 && scope.row.courses_count > 0"
                                slot="tag"
                                type="danger"
                                size="tiny">Needs Beacon</app-tag>
                        </template>
                    </el-table-column>
                </el-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>

        <modal v-model="showAddLocation" size="small">
            <location-edit-view/>
        </modal>

        <modal v-model="showActivateBeacon" size="small">
            <activate-beacon-view :no-location="true"/>
        </modal>
    </dashboard>
</template>

<script>
import { mapGetters } from 'vuex'
import table from '@/mixins/table'

import LocationEditView from './LocationEditView'
import ActivateBeaconView from './ActivateBeaconView'
import Location from '@/store/models/Location'

export default {
    name: 'page-locations',
    components: {
        LocationEditView,
        ActivateBeaconView
    },
    mixins: [table],
    head: {
        title: {
            inner: 'Locations'
        }
    },
    data() {
        return {
            locations: [],
            total: 0,
            query: "",
            showAddLocation: false,
            tableParamKeys: ['query'],
            showActivateBeacon: false,
        }
    },
    computed: {
        ...mapGetters(['role'])
    },
    created() {
        this.getLocations(this.getParameters())
    },
    methods: {
        getLocations(params) {
            Location.$fetchAll(params)
                .then(({ data, raw }) => {
                    this.locations = data
                    this.total = raw.total
                })
        },
        navigateToLocationDetail(location) {
            this.$router.push({
                name: 'locations.detail',
                params: { id: location.id }
            })
        },
        addNewLocation() {
            this.showAddLocation = true
        },
        queryChange(query) {
            let params = this.getParameters()
            params.query = query
            this.getLocations(params)	
        },		
        paramsChanged(params) {
            this.getLocations(params)
        }
    }
}
</script>

<style lang="stylus">
@media only screen and (max-width: 760px)
    #list-add-beacon
        display: none
</style>
